import { render } from "./photo-viewer.vue?vue&type=template&id=57088a64&scoped=true"
import script from "./photo-viewer.vue?vue&type=script&lang=js"
export * from "./photo-viewer.vue?vue&type=script&lang=js"

import "./photo-viewer.vue?vue&type=style&index=0&id=57088a64&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57088a64"]])

export default __exports__